var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000610352,
    width: 39.9999,
    height: 39.9998,
    rx: 19.9999,
    fill: "#609EFC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7706 16.7501C16.66 15.3154 16.9915 13.8813 17.7206 12.6408C18.4496 11.4003 19.5412 10.4129 20.8484 9.81151C22.1556 9.21013 23.6157 9.02365 25.0321 9.27716C26.4485 9.53067 27.7532 10.212 28.7707 11.2295C29.7881 12.2469 30.4695 13.5517 30.723 14.968C30.9765 16.3844 30.79 17.8445 30.1886 19.1517C29.5872 20.4589 28.5998 21.5505 27.3593 22.2795C26.1188 23.0086 24.6847 23.3401 23.2501 23.2295M30.8334 25.4167C30.8334 26.2787 30.491 27.1054 29.8815 27.7148C29.272 28.3243 28.4453 28.6667 27.5834 28.6667H25.4167M25.4167 28.6667L27.5834 26.5001M25.4167 28.6667L27.5834 30.8334M9.16672 14.5834C9.16672 13.7215 9.50913 12.8948 10.1186 12.2853C10.7281 11.6758 11.5548 11.3334 12.4167 11.3334H14.5834M14.5834 11.3334L12.4167 13.5001M14.5834 11.3334L12.4167 9.16675M16.2084 30.8334C14.3408 30.8334 12.5497 30.0915 11.2292 28.771C9.90861 27.4504 9.16672 25.6593 9.16672 23.7917C9.16672 21.9242 9.90861 20.1331 11.2292 18.8125C12.5497 17.492 14.3408 16.7501 16.2084 16.7501C18.076 16.7501 19.867 17.492 21.1876 18.8125C22.5082 20.1331 23.2501 21.9242 23.2501 23.7917C23.2501 25.6593 22.5082 27.4504 21.1876 28.771C19.867 30.0915 18.076 30.8334 16.2084 30.8334Z",
    stroke: "#609EFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.417ab18fea14ea35c25befc9cbd61fb0.svg";
export { ForwardRef as ReactComponent };